import React, {useEffect, useState} from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { isBrowser } from "react-device-detect";
import WarningNotiifcation from 'components/WarningNotification';
import Form from 'react-bootstrap/Form';

const mt15 = {
    marginTop: 5
}

const isBrowserMt = isBrowser ? mt15 : null;

const EducationCard = ({data}) => {
    const [education, setEducation] = useState([]);

    useEffect( () => {
        setEducation(data);
    }, [data])
    return (
      <>
       {
        education.length > 0 ? 
        education.map((element) => {
         return (
          <Card key={element.id} style={mt15}>
              <Card.Body className={'p-30'}>
                <Row>
                    <Col xs={isBrowser ? 6 : 12}>
                        <Row>
                            <Col xs={isBrowser ? 3 : 12}>
                                <strong> Centro educativo </strong>
                            </Col>
                            <Col xs={isBrowser ? 9 : 12}>
                                {element.escuela}
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Área de estudio </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                {element.estudioAreNombre}
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Título </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                            {element.titulo}
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Nivel </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                {element.estudioNivelNombre}
                            </Col>
                        </Row>
                    </Col>
                    <Col style={!isBrowser ? mt15 : null}  xs={isBrowser ? 6 : 12}>
                        <Row>
                            <Col xs={isBrowser ? 3 : 12}>
                                <strong> Desde </strong>
                            </Col>
                            <Col xs={isBrowser ? 9 : 12}>
                                {element.anioInicio ? element.anioInicio : 'No especificado'}
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Hasta </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                {element.anioFin ? element.anioFin : 'No especificado'}
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Actual </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                             {(element.actual === 0)? 'No' : 'Si'}
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Horario </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                             {element.horarioTipoNombre ? element.horarioTipoNombre : 'no especificado'}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {/* <Row>
                    <Col style={{marginTop: 10}} xs={12}>
                        <Row>
                            <Col xs={12}>
                                <strong> Descripción </strong>
                            </Col>
                            <Col style={{marginTop: 10}} xs={12}>
                                <span style={{textAlign:'justify'}}>
                                    { element.descripcion ? element.descripcion : 'no especificado' }
                                </span>
                            </Col>
                        </Row>
                    </Col>
                </Row> */}
            </Card.Body>
          </Card>
          )
         })
          :
          <Form.Group as={Col} md="12">
            <WarningNotiifcation message='No ha agregado ' enphasis='educación'/>
          </Form.Group>
       }
      </>    
    );
};

export default EducationCard;